import React from "react";
import { Typography } from "antd";

const { Paragraph } = Typography;

const MessageAppTimeoutError = (props) => {
  return (
    <div className="text-start">
      <Paragraph>
        The detection application failed to run, and it was not able to gather
        the necessary data to accurately analyze this computer.
      </Paragraph>
      <Paragraph>
        The detection application must be downloaded and run to continue.
      </Paragraph>

      <Paragraph>
        You can retry the detection process (recommended) or cancel the
        detection.
      </Paragraph>
    </div>
  );
};

export default MessageAppTimeoutError;
